
enum ReCaptchaAction {
    SignUp = "SignUp",
    SignUpSSO = "SignUpSSO",
    Login = "Login",
}

export default ReCaptchaAction;